// styles.js — VectorVault Design System
// Matches the landing page theme: #080808 bg, #00d67a accent, Inter + JetBrains Mono

export const darkStyles = {
  wrapper: {
    backgroundColor: "#080808",
    minHeight: "100vh",
  },
  userCredits: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#ffffff",
    backgroundColor: "#0d0d0d",
    padding: "10px 16px",
    borderRadius: "8px",
    border: "1px solid #1a1a1a",
    marginBottom: "20px",
  },
  body: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#ffffff",
    backgroundColor: "#080808",
    padding: "20px",
    textAlign: "left",
  },
  refresh: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    lineHeight: "1.5",
    color: "#999999",
    backgroundColor: "#080808",
    paddingLeft: "4px",
    textAlign: "left",
  },
  h1: {
    marginTop: "0",
    fontWeight: "700",
    letterSpacing: "-0.02em",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    marginLeft: "-4px",
    fontWeight: "600",
    color: "#e0e0e0",
    fontSize: "14px",
  },
  yourmsgLabel: {
    display: "block",
    fontSize: "1.2rem",
    marginTop: "30px",
    marginBottom: "8px",
    fontWeight: "600",
    color: "#ffffff",
  },
  textarea: {
    width: "100%",
    fontFamily: "'JetBrains Mono', monospace",
    color: "#ffffff",
    backgroundColor: "#111111",
    border: "1px solid #222222",
    borderRadius: "8px",
    padding: "12px",
    resize: "vertical",
    fontSize: "0.95rem",
    paddingLeft: "12px",
    transition: "border-color 0.2s, box-shadow 0.2s",
    outline: "none",
  },
  button: {
    backgroundColor: "#00d67a",
    color: "#000000",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    padding: "10px 20px",
    fontSize: "15px",
    fontWeight: "600",
    marginTop: "16px",
    marginBottom: "10px",
    transition: "background-color 0.2s, transform 0.1s",
    fontFamily: "'Inter', sans-serif",
  },
  btn: {
    background: 'none',
    border: 'none',
    padding: '3px 10px',
    fontSize: '0.95rem',
    color: '#999999',
    cursor: 'pointer',
    textAlign: 'center',
    marginLeft: '5px',
    marginBottom: '2px',
    textDecoration: 'none',
    display: 'inline-block',
    transition: 'color 0.2s',
  },
  bttn: {
    padding: '6px 14px',
    fontSize: '0.95rem',
    color: '#ffffff',
    backgroundColor: '#0d0d0d',
    border: '1px solid #1a1a1a',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, border-color 0.2s',
    textAlign: 'center',
    display: 'inline-block',
    marginLeft: '5px',
    marginBottom: '2px',
    textDecoration: 'none',
  },
  sleekInput: {
    border: '1px solid #222222',
    color: '#ffffff',
    backgroundColor: '#111111',
    borderRadius: '8px',
  },
  apiInput: {
    flexGrow: 1,
    margin: '0 15px',
    maxWidth: '420px',
    border: '1px solid #222222',
    padding: '8px 12px',
    borderRadius: '8px',
    outline: 'none',
    color: '#ffffff',
    backgroundColor: '#111111',
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: '0.9rem',
    transition: 'border-color 0.2s',
  },
  buttonHover: {
    backgroundColor: "#00b368",
  },
  responseContainer: {
    marginTop: "60px",
    marginBottom: "20px",
    marginRight: "-8px",
    marginLeft: "-8px",
    padding: "20px 16px",
    paddingBottom: "20px",
    borderRadius: "12px",
    backgroundColor: "#0d0d0d",
    border: "1px solid #1a1a1a",
    textAlign: "left",
  },
  chatResponseContainer: {
    marginTop: "16px",
    marginBottom: "150px",
    marginLeft: "-8px",
    padding: "20px",
    paddingBottom: "10px",
    borderRadius: "12px",
    backgroundColor: "#0d0d0d",
    border: "1px solid #1a1a1a",
    textAlign: "left",
  },
  responseContainerShow: {
    display: "block",
  },
  responseContainerH3: {
    marginTop: "0px",
    fontSize: "16px",
    fontWeight: "600",
  },
  response: {
    whiteSpace: "pre-wrap",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "14px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "#e0e0e0",
  },
  logo: {
    whiteSpace: "pre-wrap",
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "#ffffff",
  },
  loadingSpinner: {
    display: "none",
    marginTop: "16px",
    textAlign: "center",
  },
  loadingSpinnerSvg: {
    width: "30px",
    height: "30px",
  },
  loadingSpinnerCircle: {
    strokeDasharray: "113",
    strokeDashoffset: "113",
    transformOrigin: "center",
    animation: "spin 1s linear infinite, draw 1s linear infinite",
  },
  userMessage: {
    textAlign: 'left',
    fontSize: "0.95rem",
    backgroundColor: "#111111",
    borderRadius: '8px',
    color: '#00d67a',
    marginBottom: '0.5rem',
    marginLeft: "4px",
    padding: "10px 12px",
    marginRight: '-8px',
    whiteSpace: 'pre-wrap',
    border: '1px solid #1a1a1a',
  },
  notificationStyle: {
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid #1a1a1a',
    marginBottom: '20px',
    backgroundColor: "#0d0d0d",
    color: "#ffffff",
    fontWeight: '600',
    position: 'fixed',
    top: '120px',
    right: '20px',
    zIndex: 999,
    fontSize: '14px',
  },
  botMessage: {
    textAlign: 'left',
    fontSize: "0.95rem",
    color: '#e0e0e0',
    marginBottom: '0.5rem',
    marginRight: '-6px',
    padding: "10px 4px",
    whiteSpace: 'pre-wrap',
  },
  chatResponse: {
    borderRadius: "8px",
    marginBottom: "8px",
    padding: "12px",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "0.95rem",
    backgroundColor: "#111111",
    border: "1px solid #1a1a1a",
    whiteSpace: 'pre-wrap',
  },
};

export const lightStyles = {
  wrapper: {
    backgroundColor: "#f7f8fa",
    minHeight: "100vh",
  },
  userCredits: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#111827",
    backgroundColor: "#ffffff",
    padding: "10px 16px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
    marginBottom: "20px",
  },
  body: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#111827",
    backgroundColor: "#f7f8fa",
    padding: "20px",
    textAlign: "left",
  },
  refresh: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "14px",
    lineHeight: "1.5",
    color: "#6b7280",
    backgroundColor: "#f7f8fa",
    paddingLeft: "4px",
    textAlign: "left",
  },
  h1: {
    marginTop: "0",
    fontWeight: "700",
    letterSpacing: "-0.02em",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    color: "#374151",
    fontSize: "14px",
  },
  yourmsgLabel: {
    display: "block",
    fontSize: "1.2rem",
    marginTop: "30px",
    marginBottom: "10px",
    fontWeight: "600",
    color: "#111827",
  },
  textarea: {
    width: "100%",
    fontFamily: "'JetBrains Mono', monospace",
    color: "#111827",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "12px",
    resize: "vertical",
    fontSize: "0.95rem",
    paddingLeft: "12px",
    transition: "border-color 0.2s, box-shadow 0.2s, background-color 0.2s",
    outline: "none",
    boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.04)",
  },
  button: {
    backgroundColor: "#00d67a",
    color: "#06281a",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    padding: "10px 20px",
    fontSize: "15px",
    fontWeight: "600",
    marginTop: "16px",
    marginBottom: "10px",
    transition: "background-color 0.2s, transform 0.1s",
    fontFamily: "'Inter', sans-serif",
  },
  btn: {
    background: 'none',
    border: 'none',
    padding: '3px 10px',
    fontSize: '0.95rem',
    color: '#6b7280',
    cursor: 'pointer',
    textAlign: 'center',
    marginLeft: '5px',
    marginBottom: '2px',
    textDecoration: 'none',
    display: 'inline-block',
    transition: 'color 0.2s',
  },
  bttn: {
    padding: '6px 14px',
    fontSize: '0.95rem',
    color: '#111827',
    backgroundColor: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s, border-color 0.2s',
    textAlign: 'center',
    display: 'inline-block',
    marginLeft: '5px',
    marginBottom: '2px',
    textDecoration: 'none',
  },
  sleekInput: {
    border: '1px solid #d1d5db',
    color: '#111827',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
  },
  apiInput: {
    flexGrow: 1,
    margin: '0 15px',
    maxWidth: '420px',
    border: '1px solid #d1d5db',
    padding: '8px 12px',
    borderRadius: '8px',
    outline: 'none',
    color: '#111827',
    backgroundColor: '#ffffff',
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: '0.9rem',
  },
  buttonHover: {
    backgroundColor: "#00b368",
  },
  responseContainer: {
    marginTop: "60px",
    marginBottom: "20px",
    marginRight: "-8px",
    marginLeft: "-8px",
    padding: "20px 16px",
    paddingBottom: "20px",
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    textAlign: "left",
  },
  chatResponseContainer: {
    marginTop: "16px",
    marginBottom: "50px",
    marginLeft: "-8px",
    padding: "20px 16px",
    paddingBottom: "10px",
    borderRadius: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    textAlign: "left",
  },
  responseContainerShow: {
    display: "block",
  },
  responseContainerH3: {
    marginTop: "0",
    fontSize: "16px",
    fontWeight: "600",
  },
  response: {
    whiteSpace: "pre-wrap",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "14px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "#374151",
  },
  logo: {
    whiteSpace: "pre-wrap",
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "#111827",
  },
  notificationStyle: {
    padding: '12px 16px',
    borderRadius: '8px',
    border: '1px solid #bbf7d0',
    marginBottom: '20px',
    backgroundColor: "#ecfdf5",
    color: "#065f46",
    fontWeight: '600',
    position: 'fixed',
    top: '120px',
    right: '20px',
    zIndex: 999,
    fontSize: '14px',
  },
  loadingSpinner: {
    display: "none",
    marginTop: "16px",
    textAlign: "center",
  },
  loadingSpinnerSvg: {
    width: "30px",
    height: "30px",
  },
  loadingSpinnerCircle: {
    strokeDasharray: "113",
    strokeDashoffset: "113",
    transformOrigin: "center",
    animation: "spin 1s linear infinite, draw 1s linear infinite",
  },
  userMessage: {
    textAlign: 'left',
    fontSize: "0.95rem",
    padding: "10px 12px",
    marginLeft: "4px",
    marginRight: "4px",
    backgroundColor: "#ecfdf5",
    borderRadius: '8px',
    color: '#065f46',
    marginBottom: '0.5rem',
    whiteSpace: 'pre-wrap',
    border: '1px solid #bbf7d0',
  },
  botMessage: {
    textAlign: 'left',
    fontSize: "0.95rem",
    padding: "10px 4px",
    marginBottom: '0.5rem',
    whiteSpace: 'pre-wrap',
    color: '#374151',
  },
  chatResponse: {
    borderRadius: "8px",
    marginBottom: "8px",
    padding: "12px",
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: "0.95rem",
    backgroundColor: "#f3f4f6",
    border: "1px solid #e5e7eb",
    whiteSpace: 'pre-wrap',
  },
};
